<template>
  <div class="businesscase" id="activebc" v-if="bc">
  <b-button @click="complete(bc)" title="complete" variant="success" class="float-right">
    <b-icon v-if="bc.status=='ACTIVE'" variant="light" icon="check-circle" font-scale="1.5" class="float-right"></b-icon>
    Complete
  </b-button>

  <b-button @click="cancel(bc)" title="cancel" variant="danger" class="float-right mr-2">
    <b-icon v-if="bc.status=='ACTIVE'" variant="light"  icon="x-circle" font-scale="1.5" class="float-right" ></b-icon>
    Cancel
  </b-button>

  <h3>{{bc.id}}: {{bc.name}}</h3>

  <div class="clearfix"></div>

  <b-row>
    <b-col sm="6">
      <Task v-for="task in tasksFirstHalf" :key="task.id" v-bind:task="task" ></Task>
    </b-col>
    <b-col sm="6">
      <Task v-for="task in tasksSecondHalf" :key="task.id" v-bind:task="task" ></Task>
    </b-col>
  </b-row>
<!--
  <pre v-if="bc">


    {{bc}}
  </pre>
-->
  </div>
</template>

<script>
import Task from '@/components/Task'

export default {
  name: 'BusinessCase',
  props: ['bc'],
  components: {
    Task
  },
  computed: {
    tasksFirstHalf() {
      if(this.bc && this.bc.tasks ) {
        var nr = this.bc.tasks.length;
        return (nr > 2) ? this.bc.tasks.slice(0, nr/2+1) : this.bc.tasks.slice(0, nr/2);
      }
      return null;
    },
    tasksSecondHalf() {
      if(this.bc && this.bc.tasks ) {
        var nr = this.bc.tasks.length;
        return (nr > 2) ? this.bc.tasks.slice(nr/2+1, nr) : this.bc.tasks.slice(nr/2, nr);
      }
      return null;
    },
    dialog () {
      return this.$store.state.dialog;
    }
  },
  methods: {
    cancel(bc) {
      this.$store.dispatch('setBusinessCaseStatusInDialogue', { 'dialogId': this.dialog.dialogueId, 'businessCaseId': bc.id , 'status': 'CANCELLED'});
    },
    complete(bc) {
      this.$store.dispatch('setBusinessCaseStatusInDialogue', { 'dialogId': this.dialog.dialogueId, 'businessCaseId': bc.id , 'status': 'COMPLETED'});
    }
  }
}
</script>

<style scoped>

</style>
